import api from './api';
import Cliente from '../shared/entity/Cliente';

const BASE_URL = '/auth';

class AuthApi {
  isAuthenticated() {
    // return localStorage.getItem(TOKEN_KEY) !== null;
  }

  getToken() {
    // return localStorage.getItem(TOKEN_KEY);
  }

  async login(email: string, senha: string) {
    try {
      let res = await api.post<{ token: string; cliente: Cliente }>(BASE_URL, { email, senha });
      let data = res.data;
      return data;
    } catch (err) {
      console.log(err);
    }
  }

  async loginGoogle(tokenGoogle: string) {
    try {
      let res = await api.post<{ token: string; cliente: Cliente }>(BASE_URL + '/loginGoogle', {
        tokenGoogle
      });
      let data = res.data;
      return data;
    } catch (err) {
      console.log(err);
    }
  }

  async revalidate() {
    let res = await api.get<{ token: string; cliente: Cliente }>(BASE_URL);
    let data = res.data;
    return data;
  }

  logout() {
    // localStorage.removeItem(TOKEN_KEY);
    // TODO NAVIGATE TO LOGIN?
    return false;
  }
}

export default new AuthApi();
